var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsuranceCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.167 60.5C46.7355 60.5 60.167 47.0685 60.167 30.5C60.167 13.9315 46.7355 0.5 30.167 0.5C13.5984 0.5 0.166992 13.9315 0.166992 30.5C0.166992 47.0685 13.5984 60.5 30.167 60.5Z",
    fill: "#FCF7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.512 13.7197C41.294 13.5011 41.0349 13.3276 40.7497 13.2093C40.4644 13.091 40.1587 13.0302 39.8499 13.0303H21.0206C20.3967 13.0307 19.7985 13.2789 19.3575 13.7202C18.9165 14.1616 18.6689 14.76 18.6689 15.3839V43.6273C18.6689 44.2512 18.9165 44.8496 19.3575 45.2909C19.7985 45.7323 20.3967 45.9804 21.0206 45.9808H39.8496C40.4736 45.9797 41.0718 45.7315 41.5133 45.2904C41.9548 44.8493 42.2036 44.2513 42.2053 43.6273V15.3839C42.2054 15.0744 42.1441 14.7681 42.0252 14.4824C41.9062 14.1968 41.7317 13.9376 41.512 13.7197V13.7197Z",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0364 17.9727H22.8359V23.4451H38.0364V17.9727Z",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0364 28.125H22.8359",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0364 32.3975H22.8359",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0364 36.6738H22.8359",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0364 40.9463H22.8359",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceCard);
export default __webpack_public_path__ + "static/media/insurance-card.8d8ea874f748321d5eca0ba184135d39.svg";
export { ForwardRef as ReactComponent };